<!-- 通用组件 - 分页组件 -->
<!-- 有同步和异步两种方式，通过父组件在 Paging 组件上绑定 isAsync prop，来标识同步还是异步请求-->
<!--
 1. 同步方式：在地址栏传递 query: pageNum（可能还会有pageSize），由组件在router change里和页面初始化时获取。
    Paging 组件则在页面切换时通过 push 新的 router query 来更新地址栏
    优点：可以在拦截时保存请求地址，完成之前操作后继续之前的访问
    例子：ResultContainer.vue


 2. 异步方式：Paging 组件向父组件 emit goto方法，将用户选择的 pageNum 抛到父组件中，由父组件更新 pageNum 并更新数据
    优点：地址栏比较干净简洁
    例子：个人中心页的几个组件：AccountBalance.vue、MyEvidences.vue 等。

 -->
<template>
  <div class="page_container">
    <ul class="nav page">
      <li class="single_page" v-if="!page.firstPage" @click="goto(page.pageNumber - 1)">上一页</li>
      <li class="specified_page" v-for="n in page.shown"
          :class="{selected: n == page.pageNumber - page.startPage + 1}"
          @click="goto(n + page.startPage - 1)">
        {{n + page.startPage - 1}}
      </li>
      <li class="single_page" v-if="!page.lastPage" @click="goto(page.pageNumber + 1)">下一页</li>
    </ul>
  </div>
</template>

<style scoped>
  .page_container {
    width: 100%;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .page li{
    border-radius: 1px;
    border: solid 1px #e6e6e6;
    cursor: pointer;
    /*height: 0.75rem;
    line-height: 0.75rem;*/
    font-size: 12px;
    text-align: center;
    color: #a12935;
    padding: 4px 7px;
    margin-right: 5px;
  }

  /*.page li.single_page{*/
  /*width: 36px;*/
  /*}*/
  .page li.selected{
    background-color: #be2231;
    color: #ffffff;
  }
</style>

<script>
  export default {
    name: 'Paging',
    props: ['page', 'isAsync'],
    data(){
        return {

        }
    },
    methods: {
        goto(pageNum){
            if(pageNum == this.page.pageNumber){
                return;
            }
//            console.log(this.$router);
            if(this.isAsync){  //异步方式向父组件传递pageNum
              this.$emit('gotoPage', pageNum);
            }else{    //同步方式更新地址栏参数，由父组件监测地址栏变化
              let query = this.$router.history.current.query;
              let path = this.$router.history.current.path;
              let newQuery = {};
              for(let key in query){
                if(key == 'pageNum'){
                  newQuery[key] = pageNum;
                }else{
                  newQuery[key] = query[key];
                }
              }
              this.$router.push({path, query:newQuery});
            }

//            console.log('router change to ', this.$router.history.current);
        }
    }
  }
</script>



// WEBPACK FOOTER //
// Paging.vue?44d65a0f